module.exports = __webpack_public_path__ + "media/BadWolves-Zombie.c5e685aa.mp3";